import { sessionStore, updateSession } from "../../stores/session";
import { get } from "svelte/store";
import { validateIdentifier } from "../../api/user";
import { decodeJWT, type JwtPayload } from "../../public/lib/helpers/jwt";

const ONE_SECOND_MS = 1000;

export enum JWTFlavour {
  MICROSITE,
  FOLLOW_UP_SURVEY
}

export const decodeAndValidate = (jwt: string) => {
  try {
    const jwtData = decodeJWT(jwt);
    if (jwtData.exp * ONE_SECOND_MS < Date.now()) {
      return null;
    }
    return jwtData;
  } catch (e) {
    return null;
  }
};

export const updateJWT = (jwt: string | null) => {
  if (!jwt) return;

  const data: JwtPayload | null = decodeAndValidate(jwt);

  if (data) {
    updateSession({ jwt, foojiData: data.fooji_data, authCompleted: true });
  } else {
    updateSession({ jwt: undefined });
  }
};

// If the JWT is a follow-up-survey JWT it will have no identifier
export const identifyJWT = (jwtData: JwtPayload) => {
  return jwtData.identifier ? JWTFlavour.MICROSITE: JWTFlavour.FOLLOW_UP_SURVEY;
};

export const validateHandle = async (jwt: string) => {
  const identifier = get(sessionStore).foojiData?.campaign_user?.identifier;
  if (identifier) {
    const result = await validateIdentifier(identifier, jwt);
    if (!result.success) {
      throw new Error("Invalid identifier");
    }
  } else {
    throw new Error("No identifier found in session");
  }
};
